import { ImageScaleView, View } from '@play-co/timestep-core/ui';
import BaseLeaderboardsPage from './BaseLeaderboardsPage';
import { AsyncScroll } from 'src/game/components/shared/AsyncScroll';
import { LeaderboardsMemberEntry } from './LeaderboardsMemberEntry';
import { Feature } from 'src/replicant/analytics';
import {
  WeeklyLeaderboardMemberData,
  getWeeklyLeaderboardFriendsRanking,
} from '../weeklyLeaderboard.utils';
import { ScrollShortcuts } from './ScrollShortcuts';
import { user } from 'src/StateObserver';

export default class LeaderboardsFriendsPage extends BaseLeaderboardsPage {
  private scroll!: AsyncScroll<
    WeeklyLeaderboardMemberData,
    LeaderboardsMemberEntry
  >;
  protected header: ImageScaleView;
  protected contentView: View;

  constructor(superview: View) {
    super(superview);

    this.contentView = new View({
      superview: this,
      height: 0,
    });

    this.header = new ImageScaleView({
      superview: this.contentView,
    });

    this.addContent();
  }

  private addContent() {
    this.scroll = new AsyncScroll({
      superview: this,
      rect: {
        x: 0,
        y: 0,
        width: this.style.width,
        height: this.style.height,
      },
      firstItemOffset: 20,
      lastItemOffset: 20,
      createItem: (superview, index, data) => {
        const entry = new LeaderboardsMemberEntry({
          superview,
          weeklyPage: false,
        });
        entry.on('Close', () => {
          this.emit('Close');
        });
        entry.style.x = (superview.style.width - entry.style.width) * 0.5;
        if ('loading' in data) return entry;
        const position = index + 1;
        entry.setup({ ...data, position });
        return entry;
      },
      recycle: true,
      setData: (index, data, view) => {
        if ('loading' in data) return;
        const position = index + 1;
        view.setup({ ...data, position });
      },
    });

    new ScrollShortcuts(this.scroll);

    const stickyView = new LeaderboardsMemberEntry({
      weeklyPage: false,
    });
    stickyView.updateOpts({
      offsetX: 10,
      offsetY: 7,
    });

    this.scroll.setDataProvider(
      async () => {
        const players = await getWeeklyLeaderboardFriendsRanking().get();
        const player = players.find((player) => player.id === user().id);
        if (player) {
          this.scroll.setStickyItem(stickyView, players.indexOf(player));
          stickyView.setup(player);
        } else {
          this.scroll.clearStickyItem();
        }
        return players;
      },
      {
        feature: Feature.WEEKLY_LEADERBOARD._,
        subFeature: Feature.WEEKLY_LEADERBOARD.GET_FRIENDS,
      },
    );
  }
}
